import { getApiClient } from './ApiClient'

export const partnerWorkoutCategoryListPromise = (params) => {
  return getApiClient()
    .get('/partner-workout-categories', {
      params
    })
    .then(resp => {
      return Promise.resolve(resp.data)
    })
}

export const partnerWorkoutCategoryDetailPromise = (id) => {
  return getApiClient()
    .get(`/partner-workout-categories/${id}`)
    .then(resp => {
      return Promise.resolve(resp.data)
    })
}

export const partnerWorkoutCategoryUpsertPromise = (body) => {
  return getApiClient()
    .post('/partner-workout-categories/upsert', {
      body
    })
    .then(resp => {
      return Promise.resolve(resp.data)
    })
}
